<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isRecyclingBinDetailLoading">
      <div class="tab-info-card">
        <div class="user-detail">
          <div class="tab-info-title">设备基本信息</div>
          <div class="tab-info-content tab-base">
            <div class="tab-base-item">
              <span class="tab-base-label">摄像头序列号：</span>
              <span class="tab-base-value">{{detailFormData.cam}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">SN：</span>
              <span class="tab-base-value">{{detailFormData.sn}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">箱体名称：</span>
              <span class="tab-base-value">{{detailFormData.boxName}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">箱体地址：</span>
              <span class="tab-base-value">{{detailFormData.addr}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">投递单价(元)：</span>
              <span class="tab-base-value">{{detailFormData.unitPrice}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">开箱费用：</span>
              <span class="tab-base-value">{{detailFormData.upMoney}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">公司名称：</span>
              <span class="tab-base-value">{{detailFormData.companyName}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">地址：</span>
              <span class="tab-base-value">{{detailFormData.companyAddress}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">到期时间：</span>
              <span class="tab-base-value">{{detailFormData.expiryDate}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">上锁状态：</span>
              <span class="tab-base-value">
                <el-tag type="success" v-if="detailFormData.locked === 1">未锁定</el-tag>
                <el-tag v-else-if="detailFormData.locked === 2">已锁定</el-tag>
              </span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">状态：</span>
              <span class="tab-base-value">
                <el-tag type="success" v-if="detailFormData.status === 0">正常</el-tag>
                <el-tag v-else-if="detailFormData.status === 1">满溢</el-tag>
                <el-tag v-else-if="detailFormData.status === 16">异常</el-tag>
              </span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">创建时间：</span>
              <span class="tab-base-value">{{detailFormData.createdAt}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">安装时间：</span>
              <span class="tab-base-value">{{detailFormData.installTime}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">最后上线时间：</span>
              <span class="tab-base-value">{{detailFormData.lastOnlineTime}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">座机：</span>
              <span class="tab-base-value">4007000097</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">手机：</span>
              <span class="tab-base-value">13581681083</span>
            </div>
          </div>
        </div>
      </div>
      <!-- tab内容 -->
      <div class="tab-info-card tab-info-padding">
        <div class="tab-info-title">
          <span>其他信息</span>
        </div>
        <el-row>
          <el-col :span="4" style="margin-right: 20px;">
            <h2>箱体信息</h2>
            <div class="tab-info-content tab-base" style="padding-left: 0px;">
              <div class="tab-base-item">
                <span class="tab-base-label">回收箱名称：</span>
                <span class="tab-base-value">{{detailFormData.boxName}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">安装地址：</span>
                <span class="tab-base-value">{{detailFormData.addr}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">安装时间：</span>
                <span class="tab-base-value">-</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">第一次使用时间：</span>
                <span class="tab-base-value">{{detailFormData.installTime}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">运行天数：</span>
                <span class="tab-base-value">{{ totalDays(detailFormData.installTime,detailFormData.lastOnlineTime) }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <h2>清运数据</h2>
            <div class="tab-info-content tab-base" style="padding-left: 0px;">
              <div class="tab-base-item">
                <span class="tab-base-label">今日清运量：</span>
                <span class="tab-base-value">{{detailFormDataMore.qyDay}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">昨日清运量：</span>
                <span class="tab-base-value">{{detailFormDataMore.qyYesterdayWeight}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">本月清运量：</span>
                <span class="tab-base-value">{{detailFormDataMore.qyMonth}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">上月清运量：</span>
                <span class="tab-base-value">{{detailFormDataMore.qyLastMonth}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">总清运量：</span>
                <span class="tab-base-value">{{detailFormDataMore.qyTotal}}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <h2>投递次数</h2>
            <div class="tab-info-content tab-base" style="padding-left: 0px;">
              <div class="tab-base-item">
                <span class="tab-base-label">今日投递次数：</span>
                <span class="tab-base-value">{{detailFormDataMore.tdcsDay}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">昨日投递次数：</span>
                <span class="tab-base-value">{{detailFormDataMore.tdcsYesterdayWeight}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">本月投递次数：</span>
                <span class="tab-base-value">{{detailFormDataMore.tdcsMonth}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">上月投递次数：</span>
                <span class="tab-base-value">{{detailFormDataMore.tdcsLastMonth}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">总投递次数：</span>
                <span class="tab-base-value">{{detailFormDataMore.tdcsTotal}}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <h2>投递重量</h2>
            <div class="tab-info-content tab-base" style="padding-left: 0px;">
              <div class="tab-base-item">
                <span class="tab-base-label">今日投递量：</span>
                <span class="tab-base-value">{{detailFormDataMore.tdDay}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">昨日投递量：</span>
                <span class="tab-base-value">{{detailFormDataMore.tdYesterdayWeight}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">本月投递量：</span>
                <span class="tab-base-value">{{detailFormDataMore.tdMonth}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">上月投递量：</span>
                <span class="tab-base-value">{{detailFormDataMore.tdLastMonth}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">总投递量：</span>
                <span class="tab-base-value">{{detailFormDataMore.tdTotal}}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <h2>用户总数</h2>
            <div class="tab-info-content tab-base" style="padding-left: 0px;">
              <div class="tab-base-item">
                <span class="tab-base-label">今日新增用户：</span>
                <span class="tab-base-value">{{detailFormDataMore.zcDay}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">昨日新增用户：</span>
                <span class="tab-base-value">{{detailFormDataMore.zcYesterdayWeight}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">本月新增用户：</span>
                <span class="tab-base-value">{{detailFormDataMore.zcMonth}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">上月新增用户：</span>
                <span class="tab-base-value">{{detailFormDataMore.zcLastMonth}}</span>
              </div>
              <div class="tab-base-item">
                <span class="tab-base-label">总用户量：</span>
                <span class="tab-base-value">{{detailFormDataMore.zcTotal}}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="4"></el-col>
        </el-row>
      </div>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'RecyclingBin-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_RECYCLINGBIN',
      isSubmitLoading: false,
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      }
    }
  },
  created() {
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    },
    timeDiffMs(startTime, endTime) {
      const start = new Date(startTime).getTime()
      const end = new Date(endTime).getTime()
      return Math.abs(end - start)
    },
    totalDays(startTime, endTime) {
      return Math.floor(this.timeDiffMs(startTime, endTime) / (1000 * 60 * 60 * 24))
    }
  },
  computed: {
    ...mapState({
      isRecyclingBinDetailLoading: state => state.recyclingBin.isRecyclingBinDetailLoading,
      detailFormData: state => state.recyclingBin.recyclingBinDetailData,
      detailFormDataMore: state => state.recyclingBin.recyclingBinDetailDataMore
    })
  }
}
</script>

<style lang="scss" scoped>
.tab-info-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid rgba(228, 228, 228, 1);
  font-size: 16px;
  font-weight: 600;
  color: #444;
}
.tab-info-card {
  margin-top: 20px;
  background: #fff;

  .tab-base {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .tab-base-item {
      display: flex;
      align-items: center;
      width: 280px;
      margin-bottom: 20px;
    }
    .tab-base-label {
      width: 100px;
      text-align: right; /* 全部右对齐 */
      color: #444;
      font-weight: bold;
      margin-right: 8px;
      flex-shrink: 0;
      white-space: nowrap; /* 禁止换行 */
    }
    .tab-base-value {
      color: #444;
    }
  }
  .tab-info-content {
    padding: 20px;
  }
}
.tab-info-padding {
  padding: 20px;
}
</style>

<style lang="scss">
.user-info-card {
  .el-tabs__header {
    margin-bottom: 0;
    .el-tabs__item.is-active {
      color: #108ee9;
    }
  }
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }
  .el-tabs {
    margin-top: 20px;
  }
}
</style>
